<markant-platform-widget
  *ngFor="let widget of allWidgets"
  class="widget"
  [widget]="widget"
  [ngClass]="'size-' + widget.size"
  (widgetRemoved)="removeStaticWidget.emit($event.id)"
></markant-platform-widget>
